/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

const SET_DOM = (state, data) => {
    state.data = data
}

const SET_LOADING = state => {
    state.loading = true
}

const RESET_LOADING = state => {
    state.loading = false
}

const TOGGLE_NAV = state => {
    state.showMenu = !state.showMenu
}

const TOGGLE_EDIT = state => {
    state.isEditing = !state.isEditing
}

const RESET_STATE = state => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

const TOGGLE_PAGE_SELECTION_MODAL = state => {
    state.newPageModal.showModal = !state.newPageModal.showModal
}

const REORDER_PAGES = (state, payload) => {
    payload.list.map((item, index) => {
        item['order'] = index
    })
    state.data.sections[payload.sectionIndex].pages = payload.list
}

const REORDER_SECTIONS = (state, payload) => {
    payload.map((item, index) => {
        item['order'] = index
    })
    state.data.sections = payload
}

const SET_NEW_PAGE_OPTIONS = (state, payload) => {
    state.newPageModal.sectionId = payload.sectionId
    state.newPageModal.sectionIndex = payload.sectionIndex
    state.newPageModal.pageIndex = payload.pageIndex
}

const PATCH_PAGE = (state, payload) => {
    let page = state.data.sections[payload.sectionIndex].pages[payload.pageIndex]
    page['title'] = payload.title
    state.data.sections[payload.sectionIndex].pages.splice(payload.pageIndex, 1, page)
}

const DELETE_PAGE = (state, payload) => {
    state.data.sections[payload.sectionIndex].pages.splice(payload.pageIndex, 1)
}

const APPEND_SECTION = (state, payload) => {
    state.data.sections.push(payload)
}

const DELETE_SECTION = (state, id) => {
    state.data.sections = state.data.sections.filter(s => s.id !== id)
}

const PATCH_SECTION = (state, payload) => {
    const section = state.data.sections[payload.sectionIndex]
    section['title'] = payload.title
    state.data.sections.splice(payload.sectionIndex, 1, section)
}

const ADD_PAGE = (state, payload) => {
    let section = state.data.sections.find(s => s.id === payload.sectionId)
    section.pages.push(payload.page)
}

const SET_COMPONENT = (state, component) => {
    state.data.sections.forEach(section => {
        section.pages.forEach(page => {
            if (page.id === component.page) {
                page.components.splice(component.position, 1, component)
            }
        })
    })
}

export default {
    SET_DOM,
    ADD_PAGE,
    PATCH_PAGE,
    DELETE_PAGE,
    TOGGLE_NAV,
    RESET_STATE,
    TOGGLE_EDIT,
    SET_LOADING,
    SET_COMPONENT,
    RESET_LOADING,
    REORDER_PAGES,
    APPEND_SECTION,
    DELETE_SECTION,
    PATCH_SECTION,
    REORDER_SECTIONS,
    SET_NEW_PAGE_OPTIONS,
    TOGGLE_PAGE_SELECTION_MODAL
}



// WEBPACK FOOTER //
// ./src/state/modules/dom-alt/mutations.js